// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2cchU0_HS0_KPzOGGBQa5q","fade-in-from-top":"_1MOidR9ZJXWlbdd2vw-jYI","header":"_1TRray4y9f9JPNGezSX-tE","heading":"_2-RdijEO648Btu89tpih6B","body":"_1xjQ5_N4z1TwbkRCGrBr4q","footer":"MOn5JTgNz6ub_yzhKw2yj","alert":"_16aCY3p348mGPCK2YPWILX","confirm":"_2Uxrb-FYV0CdGEqXdnhQmb","ok-button":"_1YVMBl-XGCdnai5W-FNo5o","cancel-button":"_2whzC3TkPnHdZZTu3PdTek","spin":"K-9LkzOuqkTaqm1z7KJlX"};


//////////////////
// WEBPACK FOOTER
// ./src/public/components/View/Modal/styles.scss
// module id = 101
// module chunks = 18